import { render, staticRenderFns } from "./publishFromDate.vue?vue&type=template&id=643ed512"
import script from "./publishFromDate.vue?vue&type=script&lang=js"
export * from "./publishFromDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports